
<div *ngIf="viewModel$ | async as viewModel">

  <div *ngIf="selectedRule !== undefined" >
    <table style="margin: 0px 12px; width: 100%" id="ruleTable">
      <tr>
        <td style="padding-bottom: 12px; width:40%">
          <h4 class="control-row-name">Name:
            <i class="glyphicon glyphicon-info-sign"
               tooltip="Select a name that will explain what the rule actually do.
            'Example :- name should clearly indicate list source and what the rule maps to (eg. 'provider2phone', if provider maps to a phone number) and this name is displayed inside the message as placeholder when editing the message"></i>
          </h4>
        </td>
        <td style="padding-bottom: 12px; width:40%">
          <input type="text"
                 class="form-control list-name"
                 placeholder="Rule name"
                 name="rule_ruleName"
                 [(ngModel)]="name"
                 style="min-width: 185px; width: 100%"
                 [disabled]="selectedRule.ruleName !== undefined  && selectedRule.ruleName !== ''"
                 (keyup)="onMapChange($event)"
          />

            <span *ngIf="checkIfExists()" class="error" >The name already exists.</span>
        </td>
        <td style="padding-bottom: 12px; width:20% ">
          <button class="btn btn-primary btn-save"
                  tooltip="Clear unsaved rule to add new rule"
                  *ngIf="selectedRule !== undefined"
                  style="margin-left: 18px;"
                  (click)="clearRuleDetails()">
            Clear Rule
          </button>
        </td>
      </tr>
      <ng-template [featureFlags]="['admin:template:voice:tmp']">
      <tr>
        <td style="width:40%"><h4 class="control-row-name">Media Type:</h4></td>
        <td style="width:40%">
          <p-dropdown
              [options]="mediaTypes"
              [(ngModel)]="updatedMedia"
              [disabled]="selectedRule.mediaType !== undefined"
              styleClass="form-control"
              placeholder="Select Media"
              [style]="{'width':'100%', 'background':'white', 'border' : '1px solid #cccccc', 'color' : 'black',
              'padding-left': '16px', 'font-size': '13px', 'text-shadow': 'none'}"
              (onChange)="setSelectedMedia($event.value)"
          >
          </p-dropdown>
        </td>
      </tr>
      </ng-template>
      <tr>
        <td style="width:40%"><h4 class="control-row-name">List Source:</h4></td>
        <td style="width:40%">
          <p-dropdown
              [options]="displayReferenceType"
              [(ngModel)]="updatedReference"
              [disabled]="selectedRule.reference !== undefined"
              styleClass="form-control"
              placeholder="Select Reference"
              [style]="{'width':'100%', 'background':'white', 'border' : '1px solid #cccccc', 'color' : 'black',
              'padding-left': '16px', 'font-size': '13px', 'text-shadow': 'none'}"
              (onChange)="setSelectedReference($event.value)"
          >
          </p-dropdown>
        </td>
      </tr>
      <tr>
        <td colspan="3"><div class="rule-control-spacer"></div></td>
      </tr>
      <tr>
        <td style="width:40%"><h4 class="control-row-name">Default Value:</h4></td>
        <td style="width:40%">
          <input type="text"
            class="form-control list-name"
            placeholder="Enter default value"
            name="default_rule"
            style="min-width: 185px; width: 100%;"
            [(ngModel)]="defaultRule"
            (change)="defaultChanged(defaultRule)"
            tooltip="Default value to use in cases not listed in this rule"
        /></td>
      </tr>
      <tr>
        <td colspan="3"><div class="rule-control-spacer"></div></td>
      </tr>
    </table>

    <div style="margin: 0px 12px; width: 100%">
      <rule-entry-table *ngIf="selectedRule !== undefined && selectedReference !== undefined"
                        [rule]="selectedRule"
                        [reference]="selectedReference"
                        [ruleName]="name"
                        [mediaType]="selectedMedia"
                        [referenceTypes]="refrenceTypes"
                        [locations]="viewModel.locations"
                        [reasons]="viewModel.reasons"
                        [providers]="viewModel.providers"
                        [appointmentResources]="viewModel.appointmentResources"
                        [locationEntities]="viewModel.locationEntities"
                        [defaultRuleValue]="defaultRule"
                        (mapChanged)="onMapChange($event)"
                        (defaultChanged)="defaultChanged($event)"
                        [selectedUserId]="selectedUserId"
                        [dayOfWeek]="dayOfWeek"
      ></rule-entry-table>
    </div>
  </div>
</div>
